export const addDetailLinkFunctions = () => {
  $('._JsDetailLink:not(._js_link_initialized)')
    .click((event) => {
      const jsLinkUrl = $(event.currentTarget).data('url');

      console.log('replacing href:' + jsLinkUrl);
      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: event.target.innerText ? event.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: () => {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
      return false;
    })
    .addClass('_js_link_initialized');

  // WEB-2652 tracking click on the product/image to get the pdp
  $('._JsEventLink:not(._js_event_initialized)')
    .click((event) => {
      const helperUpselling = $(event.currentTarget);
      const action = $(event.currentTarget).data('dl-event');
      const pzn = $(event.currentTarget).data('dl-pzn');
      const basePrice = $(event.currentTarget).data('dl-baseprice');
      const grossPrice = $(event.currentTarget).data('dl-grossprice');
      const name = $(event.currentTarget).data('dl-name');

      const UpsellingList = $(event.currentTarget).parent().parent().attr('data-dl-addtocartupsellinglist');

      console.log('found action for dl:' + helperUpselling.data('dl-event'));
      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: action,
          addToCartUpsellingList: 'Add to Cart "' + UpsellingList + '"',
          addToCartUpsellingProduct: {
            grossPrice: grossPrice,
            basePrice: basePrice,
            name: name,
            pzn: pzn,
          },
        });
      }

      return false;
    })
    .addClass('_js_event_initialized');
};
